import { render, staticRenderFns } from "./SelectStatusProject.vue?vue&type=template&id=86448f68&scoped=true"
import script from "./SelectStatusProject.vue?vue&type=script&lang=js"
export * from "./SelectStatusProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86448f68",
  null
  
)

export default component.exports